var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgForesightEyesLight = function SvgForesightEyesLight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 49 48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.154 17.42c3.643-.115 8.206 3.99 15.141 6.723 2.527.994 5.26 1.793 5.653 1.905s-2.46.304-4.103.489a8.11 8.11 0 0 1-7.385 4.038c-4.849 0-7.18-3.013-7.754-6.14a9 9 0 0 1-.131-2.62s2.119-.296 6.672.74c-2.824-1.405-5.187-2.465-7.28-2.538a10.7 10.7 0 0 0-3.673.548s.652-3.097 2.86-3.146"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.847 17.42c2.207.048 2.859 3.145 2.859 3.145a10.7 10.7 0 0 0-3.673-.548c-2.092.073-4.455 1.133-7.28 2.537 4.554-1.035 6.673-.74 6.673-.74a9 9 0 0 1-.131 2.62c-.576 3.128-2.906 6.14-7.755 6.14a8.11 8.11 0 0 1-7.385-4.038c-1.642-.184-4.495-.375-4.102-.488s3.125-.911 5.652-1.905c6.935-2.733 11.498-6.838 15.142-6.724"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForesightEyesLight);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;